import { render, staticRenderFns } from "./StudyCardRecord.vue?vue&type=template&id=3851d814&"
import script from "./StudyCardRecord.vue?vue&type=script&lang=js&"
export * from "./StudyCardRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports